import { action, observable } from 'mobx';
import type { NotificationProps } from './Notification';

export class NotificationStore {
  @observable notification: NotificationProps = { isDisplayed: false };

  @action.bound
  updateNotification(notification: NotificationProps) {
    this.notification = notification;
  }

  reloadPage = () => window.location.reload();
}
